import React from 'react'

function Product(props) {
  return (
    <div>
      <div className='card'>
    <img className='product--image' src={props.url} alt="" />
{/* <h2>{props.name}</h2> */}
{/* <p className='price'>{props.price}</p> */}
{/* <p>{props.description}</p> */}
{/* <p>
    <button>Add to cart</button>
</p> */}
  </div>
  ``
    </div>
  )
}

export default Product
